import { useViewDataStore } from '../../defines/store/viewDataStore'

const navigation = [
    {
        name: 'YouTube',
        href: 'https://www.youtube.com/@sharewithdoctors',
        icon: (props: React.SVGProps<SVGSVGElement>) => (
            <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
                <path
                    fillRule="evenodd"
                    d="M19.812 5.418c.861.23 1.538.907 1.768 1.768C21.998 8.746 22 12 22 12s0 3.255-.418 4.814a2.504 2.504 0 0 1-1.768 1.768c-1.56.419-7.814.419-7.814.419s-6.255 0-7.814-.419a2.505 2.505 0 0 1-1.768-1.768C2 15.255 2 12 2 12s0-3.255.417-4.814a2.507 2.507 0 0 1 1.768-1.768C5.744 5 11.998 5 11.998 5s6.255 0 7.814.418ZM15.194 12 10 15V9l5.194 3Z"
                    clipRule="evenodd"
                />
            </svg>
        ),
    },
]

export default function Footer() {
    const activeUsers = useViewDataStore((state) => state.activeUsers)
    const screenPageViews = useViewDataStore((state) => state.screenPageViews)

    return (
        <footer className="bg-white">
            <div className="px-6 py-12 mx-auto max-w-7xl md:flex md:items-center md:justify-between lg:px-8">
                <div className="flex justify-center gap-x-6 md:order-2">
                    {navigation.map((item) => (
                        <a
                            key={item.name}
                            href={item.href}
                            className="text-gray-600 hover:text-gray-800"
                        >
                            <span className="sr-only">{item.name}</span>
                            <item.icon aria-hidden="true" className="size-6" />
                        </a>
                    ))}
                </div>
                <div className="mt-8 text-center md:order-1 md:mt-0">
                    <p className="text-xs leading-5 text-gray-500">
                        已有 {activeUsers} 位訪客，共有 {screenPageViews}{' '}
                        次瀏覽。
                    </p>
                    <p className="text-xs leading-5 text-gray-500">
                        &copy; 2020 麻醉安全通, Inc. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    )
}
